import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";

const PendingApproval = () => {
  const navigate = useNavigate();
  return (
    <div className="login-main-container h-center v-center">
      <div className="login-container w-100 position-relative">
        <Icon
          icon="material-symbols:arrow-back"
          width={20}
          height={20}
          className="back-icon"
          onClick={() => {
            navigate("/login");
          }}
        />
        <div className="input-form-main w-100">
          <div class="card border-0 ">
            <div class="card-body text-center">
              <h3 class="text-medium-black  mb-4">Approval Pending</h3>
              <p class="text-muted lead">
                Your account is not approved by admin yet!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PendingApproval;
